import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Responsible } from 'app/details-new/models';
import { CaseFunctions, CaseStylers } from '../details/caseFunctions';
import { SharedDataService } from '../../shared/services/shared-data.service';
import { Mathy } from '../../shared/utilities/shared.functions';
import { DevelopmentHelpers } from '../../shared/utilities/developHelpers';
import { CaseApi } from 'app/shared/api/case.api';
import { CaseService } from 'app/shared/services/case.service';
import { CaseTransfer, ContactDetails, PartnerInvoiceOptions } from 'app/shared/models/case.models';
import { CaseDetails } from 'app/details-new/details-new.data';
import { PartnerApi, PartnerCompany } from 'app/shared/api/partner.api';
import { InvoiceTypes } from 'app/settings/category-setup/category-setup.component';
import * as api from '../../shared/api/apihandler';
import { IdName } from 'app/shared/models/standard.models';
import { UserService } from 'app/shared/services/user.service';

@Component({
  selector: 'case-partners',
  templateUrl: './case-partners-v2.component.html',
  styleUrls: ['./case-partners-v2.component.css']
})
export class CasePartnersV2Component implements OnInit, OnChanges, OnDestroy {
  @Input() case!: CaseDetails;
  @Input() invoiceTypes: Array<InvoiceTypes> | null = null;
  api = new CaseApi(this.http);
  partnerApi = new PartnerApi(this.http);
  companyInfo
  companyInfoSubscription!: Subscription;
  casePartnerSubscription!: Subscription;
  subcontractors: Subcontractors = new Subcontractors(); // container class for displaying and manipulating visible partners
  partnerCase; // data storage for previewing partner cases
  partnerCaseAddress: 'customer' | 'delivery' = 'customer';
  hasPropertyManagement = JSON.parse(localStorage.getItem('guards') as string).find(x => x.name == '')
  propOwner;
  property;
  transferPartner: PartnerTransferData | null = null;
  files;
  fileModalId;
  selectedFiles = [];
  partnerInvoiceOptions: PartnerOptions = new PartnerOptions(null);
  showPartnerOptions: boolean = false;
  isTaurus: boolean = false;

  constructor(private http: HttpClient, private sharedData: SharedDataService, private caseServer: CaseService, private user: UserService) { }

  ngOnInit(): void {
    this.companyInfoSubscription = this.sharedData.companyInformation().subscribe({
      next: (data) => {
        if (!!data) {
          this.companyInfo = data;
          this.isTaurus = data.id == '2605daad-d63b-4ccb-9c35-bce53c4becd4' ? true : false;
        }
      },
      error: (err) => console.error(err)
    });
    // this.api.setPartnerInvoiceOptions(new PartnerInvoiceOptions())
    this.api.getPartnerInvoiceOptions().subscribe({
      next: (data: string) => {
        if (!!data) this.partnerInvoiceOptions = new PartnerOptions(JSON.parse(data) as PartnerInvoiceOptions);
        else if (!data) {
          this.partnerInvoiceOptions = new PartnerOptions(new PartnerInvoiceOptions());
          this.api.setPartnerInvoiceOptions(new PartnerInvoiceOptions());
        }
      },
      error: err => console.error('Could not get partner invoice options', err)
    });
    this.partnerApi.getTradeGroups().subscribe({
      next:(data:IdName[]) => { this.subcontractors.tradeGroups = data }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.case && !!changes.case.currentValue && changes.case.currentValue != changes.case.previousValue) {
      /**
       * Prepare case data to be transferred to
       */
      this.casePartnerSubscription = this.caseServer.casePartners(this.case.caseId).subscribe({
        next: (data) => {
          if (data) {
            this.subcontractors.connections = data;
            this.subcontractors.connectedParters = this.subcontractors.getConnectedPartners();
          }
        }
      });
      this.setup();
    }
  }

  ngOnDestroy(): void {
    this.companyInfoSubscription.unsubscribe();
    this.casePartnerSubscription.unsubscribe();
  }

  setup() {
    /**
     * Get potential offers sent from partner
     * Load badge for from partner
     * Load badges for to partners
     */
    // this.loadCasePartners();
    if (!!this.case.propertyLease && !!this.case.propertyLease.propertyId) { this.getPropertyInfo(); }
  }

  loadPartners() {
    this.reset();
    this.api.getPartners(!!this.case.propertyLease && !!this.case.propertyLease.propertyId && !!this.subcontractors.onlyPropertyContractors ? this.case.propertyLease.propertyId : null).subscribe({
      next: (data: any[]) => {
        if (!!data && data.length > 0) {
          this.subcontractors.all = data.map((x) => {
            return {
              companyId: x.companyId,
              name: x.companyName,
              connectionId: x.companiesToPartnerId,
              logo: x.logo,
              vat: x.vat,
              jubloNo: x.companyNumber.toString(),
              tradeGroup: x.tradeGroup,
              address: {
                name: x.companyName,
                address: x.address,
                zipCode: x.zipCode,
                city: x.city,
                email: x.email,
                phone: x.phone,
                mobile: x.phone,
              },
            };
          }).sort((a, b) => { return a.name < b.name ? -1 : 1; });
          this.subcontractors.displayed = this.subcontractors.all;
          this.subcontractors.search();
        } else {
          this.subcontractors.displayed = [];
          this.subcontractors.hasNoPartners = true;
        }
      },
      error: err => console.error(err),
      complete: () => document.getElementById('subcontractorSearch').focus() 
    });
  }

  getPartnerCaseDetails(partnerData) {
    this.partnerCase = null;
    this.api.getPartnerCaseInfo(partnerData.caseId).subscribe({
      next: (data) => {
        /**
         * Merge partnerData and recieved data.
         * Also find any offers that might be attached to the partner
         */
        this.partnerCase = {
          partner: partnerData,
          case: data,
          offer: this.subcontractors.connections.offers.find(x => x.caseId == partnerData.caseId)
        };
        this.partnerCaseAddress = 'customer';
        this.api.getOSCaseStatus(partnerData.caseId).subscribe({
          next: (data) => this.partnerCase.case['osStatus'] = data
        });
      }
    });
  }

  cancelTransfer(partner) {
    this.api.cancelCaseTransfer(partner.transferId).subscribe({
      error: err => console.error('Case could not be cancelled', err),
      complete: () => this.caseServer.refreshCasePartners(this.case.caseId)
    })
  }

  getOsTextColor(hex: string) {
    let hsl = Mathy.hexDecimalToHSL(Mathy.hexToHexDecimal(hex.replace('#', ''))) as { h: number, s: number, l: number };
    if (!!hsl) return hsl.l < .5 ? 'black' : 'white';
    return 'black';
  }

  createSendCase(subcontractor) {
    this.transferPartner = new PartnerTransferData(this.subcontractors.type, subcontractor, this.case);
    this.api.getPartnerResponsibles(subcontractor.companyId).subscribe({
      next: (data: any[]) => {
        this.transferPartner.responsibles = !!data ? data : [];
        this.transferPartner.caseTransfer.responsibleId = !!data && !!data.length ? data[0].id : null;
      },
      error: err => console.error(err),
      complete: () => {
        if (this.isTaurus) {
          this.transferPartner.invoice = 'propertyOwner';
        } else if (this.partnerInvoiceOptions.standard != 'auto') {
          this.transferPartner.invoice = this.partnerInvoiceOptions.standard;
        } else {
          this.transferPartner.invoice = 'company';
        }
    
        if (!!this.case.propertyLease && !!this.case.propertyLease.propertyId) {
          this.transferPartner.propertyOwner = this.propOwner;
          this.transferPartner.property = this.property;
        }
        this.transferPartner.company = this.companyInfo;
        this.transferPartner.setAddresses();
      }
    });
  }

  sendCase() {
    this.transferPartner.setAddresses();
    //console.log(this.transferPartner.caseTransfer)
    this.api.postCaseTransfer(this.transferPartner.caseTransfer).subscribe({
      error: err => console.error(err),
      complete: () => {
        let companyName = this.transferPartner.company.name;
        this.sharedData.setCaseActivity('ae99e75a-9e47-4113-bf4b-3094732cf643', 'Activity.CaseSentToPartner', companyName, '89a41c6c-6a83-4978-90bb-ca7ec2d19a26', this.case.caseId).subscribe({
          complete: () => {
          }
        });
        this.caseServer.refreshCasePartners(this.case.caseId);
      }
    });
  }

  getPropertyInfo() {
    this.api.getPropertyOwner(this.case.propertyLease.propertyId).subscribe({
      next: (data) => {
        this.propOwner = data;
      }
    });
    this.api.getPropertyById(this.case.propertyLease.propertyId).subscribe({
      next: (data) => {
        this.property = data;
      }
    })
  }

  reset() {
    setTimeout(() => {
      this.transferPartner = null;
      this.subcontractors.sendToPartnerStep = 'choose';
    }, 100)

  }

  getFiles() {
    this.api.getFilesOnCase(this.case.caseId).subscribe({
      next: (data) => this.files = data
    })
  }

  openFileSelector() {
    document.getElementById(this.fileModalId).click();
    this.getFiles();
  }

  selectFiles(files) {
    this.transferPartner.caseTransfer.files = files;
    this.getSelectedFiles(files);
  }

  getSelectedFiles(files) {
    let f = [];
    this.files.files.forEach(x => { f = f.concat(x.files) });
    let unique = Array.from(new Set(f.map(x => x.fileId)));
    let output = [];
    unique.forEach(x => {
      let file = f.find(y => y.fileId == x);
      output.push(file);
    }
    )
    this.selectedFiles = files.map(x => output.find(y => y.fileId == x));
  }

  changingInvoice() { }

  updateInvoiceType() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.patch(api.jubloApi + 'api/Website/Case/ChangeInvoiceTypeOnCase', { caseId: this.case.caseId, invoiceTypeId: this.case.invoiceTypeId }, { headers, responseType: 'text' }).subscribe({
      next: (data) => { this.case.requisitionNumber = data },
      error: err => console.error(err),
      complete: () => {
        this.transferPartner.caseTransfer.requisitionNumber = this.case.requisitionNumber;
      }
    });
  }

  acceptOffer(offer) {
    this.api.acceptOffer(offer.offerId).subscribe({
      next: () => { }
    })
  }

  rejectOffer(offer) {
    this.api.rejectOffer(offer.offerId).subscribe({
      next: () => { }
    })
  }

  getNameLetter(name) {
    return !!name ? name.replace(/[^a-zA-Z]/g, '')[0] : '';
  }

  savePartnerInputOptions() {
    console.log(this.partnerInvoiceOptions);
    this.api.setPartnerInvoiceOptions(this.partnerInvoiceOptions.toSave());
    this.partnerInvoiceOptions.visibleAmount();
  }

  removePartnerFromProperty(p) {
    this.api.removePartnerFromProperty(p.connectionId, this.property.propertyId).subscribe({
      error: err => console.error('Could not delete partner from property', err),
      complete: () => {
        this.transferPartner = null;
        this.loadPartners();
      }
    });
  }
}

export class Subcontractors {
  connections: any;
  onlyPropertyContractors = true;
  all: Array<Subcontractor> | null = null;
  displayed: Array<Subcontractor> = [];
  responsibles: Array<Responsible> = [];
  searchString: string = "";
  hasNoPartners: boolean = false;
  viewState: 'property' | 'all' | 'suggestion' = 'suggestion';
  sendToPartnerStep: 'choose' | 'form' = 'choose';
  type: 'offerRequest' | 'sendToPartner' = 'sendToPartner';
  connectedParters: string[] = [];
  chosen: Subcontractor | null = null;
  tradeGroups: IdName[] | null = null;
  filteredTradeGroups: string[] = [];
  trackByCompanyId(partner){
    return partner.companyId
  }
  search() {
    //console.log('searching', this.all)
    let s = this.searchString.toLowerCase();
    this.displayed = !!this.all ? this.all.filter(x => !!x.tradeGroup && !this.filteredTradeGroups.includes(x.tradeGroup.id) || x.tradeGroup == null && !this.filteredTradeGroups.includes(null)).filter(
      (x) => !!s && x.name.toLowerCase().match(s) ||
        (!!x.address && !!x.address.address && x.address.address.toLowerCase().match(s)) ||
        (!!x.address && !!x.address.zipCode && !!x.address.zipCode.toLowerCase().match(s)) ||
        (!!x.address && !!x.address.city && x.address.city.toLowerCase().match(s)) ||
        (!!x.vat && x.vat.toLowerCase().match(s)) ||
        (!!x.jubloNo && x.jubloNo.toLowerCase().match(s))
    ) : [];
  }
  filterTradeGroup(tradeGroupId){
    if(this.filteredTradeGroups.includes(tradeGroupId)) this.filteredTradeGroups = this.filteredTradeGroups.filter(x => x != tradeGroupId);
    else this.filteredTradeGroups.push(tradeGroupId)
    this.search();
  }

  hasCasePartner() {
    if (!!this.connections && (!!this.connections.fromPartner || !!this.connections.toPartners && !!this.connections.toPartners.length || (!!this.connections.waiting && !!this.connections.waiting.length))) return true;
    return false;
  }
  getNameLetter(name: string) {
    return !!name ? name.replace(/[^a-zA-Z]/g, '')[0] : '';
  }
  getBadgeColor(caseStatusId: string) {
    return CaseStylers.badgeColor(caseStatusId);
  }
  getConnectedPartners() {
    let c = this.connections;
    let partners = [];
    if (!!c) {
      if (!!c.from) partners.push(c.from.companyName);
      if (!!c.to) c.to.forEach(x => partners.push(x.companyName));
      if (!!c.waiting) c.waiting.forEach(x => partners.push(x.companyName));
    }
    c.waiting = c.waiting.filter(x => x.status != '36249264-3ac4-446b-a85e-81220ebfd518' && x.status != '89fc9131-c7b8-4aa4-88f3-e30d6c19a3e5');
    return partners;
  }
}

class Subcontractor {
  companyId!: string;
  name!: string;
  connectionId!: string;
  logo: string | null = null;
  vat!: string;
  jubloNo!: string;
  address: CaseTransferAddress = new CaseTransferAddress();
  tradeGroup?: IdName | null = null;
}

class CaseTransferAddress {
  name: string | null = null;
  address: string | null = null;
  zipCode: string | null = null;
  city: string | null = null;
  email: string | null = null;
  phone: string | null = null;
  mobile: string | null = null;
}

class PartnerTransferData {
  help = new DevelopmentHelpers();
  caseDetails: CaseDetails;
  caseTransfer = new CaseTransfer();
  partner;
  responsibles = [];
  propertyOwner;
  property;
  company;
  invoice: 'company' | 'case' | 'property' | 'propertyOwner' = 'case';
  newDelivery: ContactDetails = new ContactDetails();
  transferAddresses: TransferAddresses = new TransferAddresses();
  constructor(type: string, subcontractor: Subcontractor, caseDetails: CaseDetails) {
    this.caseDetails = caseDetails;
    this.partner = subcontractor;
    this.caseTransfer.connectionId = subcontractor.connectionId;
    this.caseTransfer.companyId = subcontractor.companyId;
    this.caseTransfer.caseId = caseDetails.caseId;
    this.caseTransfer.isOfferRequest = type == 'offerRequest';
    this.caseTransfer.title = !!caseDetails.title ? caseDetails.title : '';
    this.caseTransfer.description = !!caseDetails.description ? caseDetails.description : '';
    this.caseTransfer.requisitionNumber = !!caseDetails.requisitionNumber ? caseDetails.requisitionNumber : '';
    this.caseTransfer.reference = !!caseDetails.vorRef ? caseDetails.vorRef : '';
    this.setDeliveryAndContact();
  }

  setDeliveryAndContact() {
    /**
     * If no delivery exists, put customer address in delivery
     * But only if not using customer address.
     */
    if (!!this.caseDetails.deliveryAddress.id) {
      let d = this.caseDetails.deliveryAddress;
      this.transferAddresses.delivery = {
        name: d.name,
        address: d.address,
        zipCode: d.zipCode,
        city: d.city,
        email: d.email,
        phone: d.phone,
        mobile: d.mobile,
        ean: null,
        cvr: null
      }
      this.newDelivery = this.transferAddresses.delivery;
    } else {
      let d = this.caseDetails.customer;
      this.newDelivery = {
        name: d.name,
        address: d.address,
        zipCode: d.zipCode,
        city: d.city,
        email: d.email,
        phone: d.phone,
        mobile: d.mobile,
        ean: null,
        cvr: null
      }
    }

    /**
     * Only copy contact if exists
     */
    if (!!this.caseDetails.contactAddress.id) {
      let con = this.caseDetails.contactAddress;
      this.transferAddresses.contact = {
        name: con.name,
        address: con.address,
        zipCode: con.zipCode,
        city: con.city,
        email: con.email,
        phone: con.phone,
        mobile: con.mobile,
        ean:null,
        cvr:null
      };
    }
  }

  setAddresses() {
    let t = this.transferAddresses;
    switch (this.invoice) {
      case 'case': {
        let cus = this.caseDetails.customer;
        let inv = this.caseDetails.invoice;
        this.caseTransfer.cvr = null;
        this.caseTransfer.ean = null;
        this.caseTransfer.propertyName = null;
        t.customer = {
          name: cus.name,
          address: cus.address,
          zipCode: cus.zipCode,
          city: cus.city,
          email: cus.email,
          phone: cus.phone,
          mobile: cus.mobile,
          ean:null,
          cvr:null
        };
        t.invoice = {
          name: inv.name,
          address: inv.address,
          zipCode: inv.zipCode,
          city: inv.city,
          email: inv.email,
          phone: inv.phone,
          mobile: inv.mobile,
          ean:null,
          cvr:null
        };
        t.delivery = this.newDelivery;
        this.caseTransfer = { ...this.caseTransfer, ...this.transferAddresses };
        break;
      }
      case 'company': {
        this.caseTransfer.cvr = this.company.vat;
        this.caseTransfer.ean = this.company.ean;
        this.caseTransfer.propertyName = !!this.property ? this.property.name : null;
        let c = this.company;
        let a = this.help.splitAddress(c.address);
        t.customer = {
          name: c.name,
          address: a.address,
          zipCode: a.zipCode,
          city: a.city,
          email: c.email,
          phone: c.phone,
          mobile: c.mobile,
          ean:null,
          cvr:null
        };
        t.invoice = t.customer;
        t.delivery = this.newDelivery;
        this.caseTransfer = { ...this.caseTransfer, ...this.transferAddresses };
        break;
      }
      case 'property': {
        let p = this.propertyOwner;
        this.caseTransfer.propertyName = null;
        this.caseTransfer.cvr = p.cvr;
        this.caseTransfer.ean = p.ean;
        t.customer = {
          name: p.customerName,
          address: p.customerAddress,
          zipCode: p.customerZipCode,
          city: p.customerCity,
          email: p.customerEmail,
          phone: p.customerPhone,
          mobile: p.customerPhone,
          ean:null,
          cvr:null
        }
        t.invoice = t.customer;
        t.delivery = this.newDelivery;
        this.caseTransfer = { ...this.caseTransfer, ...this.transferAddresses };
        break;
      }
      case 'propertyOwner': {
        console.log(t);
        console.log(JSON.stringify(this.newDelivery));
        console.log(!!this.newDelivery.name && this.newDelivery.name != '' && !!this.newDelivery.address && this.newDelivery.name != '');
        let p = this.propertyOwner;
        this.caseTransfer.propertyName = null;
        this.caseTransfer.cvr = p.cvr;
        this.caseTransfer.ean = !!this.caseTransfer.requisitionNumber && this.caseTransfer.requisitionNumber == 'REKLAMATION' ? null : p.ean;
        t.customer = {
          name: p.invoiceName,
          address: p.invoiceAddress,
          zipCode: p.invoiceZipCode,
          city: p.invoiceCity,
          email: p.invoiceEmail,
          phone: p.invoicePhone,
          mobile: p.invoiceMobile,
          ean: null,
          cvr: null
        }
        t.invoice = t.customer;
        t.delivery = {...this.newDelivery};
        console.log(t.delivery)
        this.caseTransfer = { ...this.caseTransfer, ...this.transferAddresses };
        break;
      }
    }
  }
}

class TransferAddresses {
  customer: ContactDetails = new ContactDetails();
  invoice: ContactDetails = new ContactDetails();
  delivery: ContactDetails = new ContactDetails();
  contact: ContactDetails = new ContactDetails();
}

class PartnerOptions extends PartnerInvoiceOptions {
  numVisible: number = 3;

  constructor(partnerInvoiceOptions: PartnerInvoiceOptions | null) {
    super();
    if (!partnerInvoiceOptions) { partnerInvoiceOptions = new PartnerInvoiceOptions() }
    this.standard = partnerInvoiceOptions.standard;
    this.visible.case = partnerInvoiceOptions.visible.case;
    this.visible.company = partnerInvoiceOptions.visible.company;
    this.visible.property = partnerInvoiceOptions.visible.property;
    this.visibleAmount();
  }

  visibleAmount() {
    this.numVisible = Object.values(this.visible).reduce((total, curr) => total + (curr ? 1 : 0), 0);
  }

  toSave(): PartnerInvoiceOptions {
    return {
      standard: this.standard,
      visible: {
        case: this.visible.case,
        company: this.visible.company,
        property: this.visible.property
      }
    }
  }
}